// extracted by mini-css-extract-plugin
module.exports = {"location-info-card":"ohfa5","location-info":"_8uQ7L","hours":"ABYuk"};